/**
 * The "type the company name to confirm" prompt, shared by the delete danger zone and
 * the fake data remove-all dialog (SF-4665). The caller decides what counts as a match.
 */
import { Input, Typography } from 'antd';

const { Text, Paragraph } = Typography;

export interface TypeNameToConfirmProps {
  /** The name to type. */
  name: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Accessible label of the input. */
  ariaLabel: string;
}

export const TypeNameToConfirm: React.FC<TypeNameToConfirmProps> = ({
  name,
  value,
  onChange,
  disabled,
  ariaLabel,
}) => (
  <>
    <Paragraph style={{ marginTop: 16, marginBottom: 8 }}>
      Type <Text strong>{name}</Text> to confirm:
    </Paragraph>
    <Input
      aria-label={ariaLabel}
      placeholder={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  </>
);
